import TextField, { TextFieldSize } from '@/components/molecules/TextField';
import * as Yup from 'yup';
import validarCPF from '@/validators/validarCPF';
import { CSSProperties } from 'react';

interface TextFieldCPFProps {
  // @ts-expect-error Valor Generico
  // eslint-disable-next-line no-undef
  $errors: FieldErrors<T>;
  // @ts-expect-error Valor Generico
  // eslint-disable-next-line no-undef
  $field: ControllerRenderProps<T, 'cpf'>;
  $obrigatorio?: boolean;
  $size?: TextFieldSize;
  inputSize?: TextFieldSize;
  label?: string;
  style?: CSSProperties;
}

export const cpfMaskOptions = {
  mask: '___.___.___-__',
  replacement: { _: /\d/ },
};

export const cpfYupValidationObrigatorio = Yup.string()
  .required('O CPF é obrigatório')
  .test('cpf-valido', 'CPF inválido', (value) => {
    if (!value) return false;
    return validarCPF(value);
  });

export const cpfYupValidationNaoObrigatorio = Yup.string()
  .notRequired()
  .test('cpf-valido', 'CPF inválido', (value) => {
    if (!value) return true;
    return validarCPF(value);
  });

export default function TextFieldCPF(props: TextFieldCPFProps) {
  const {
    $errors,
    $field,
    $obrigatorio = true,
    $size = 2,
    label = 'Digite seu CPF',
    style = {},
  } = props;

  return (
    <TextField
      $size={$size}
      $variant="surface"
      $state="placeholder"
      $error={$errors.cpf?.message ?? false}
      $label={label}
      $focusRing={false}
      $placeholder="999.999.999-99"
      $name="cpf"
      $obrigatorio={$obrigatorio}
      $mask={cpfMaskOptions.mask}
      $inputProps={{
        value: $field.value,
        onBlur: $field.onBlur,
        onChange: $field.onChange,
      }}
      $style={style}
    />
  );
}
